import React, { useDeferredValue, useEffect, useRef, useState } from "react";
import Layout2 from "../../Layouts/Layout2";
import FindAgencyCard from "../common/FindAgencyCard/FindAgencyCard";
import FindAgentCard from "../common/FindAgentCard/FindAgentCard";
import search from "../../assets/search.png";
import ag1 from "../../assets/ag1.png";
import rs1 from "../../assets/rs1.png";
import rs2 from "../../assets/rs2.png";
import rs3 from "../../assets/rs3.png";
import rs4 from "../../assets/rs4.png";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import { toast } from "react-toastify";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loder from "../common/Loder";
import HeaderImg from "../../assets/findAgent/headerImg.webp";
import {
  IoCloseOutline,
  IoFilter,
  IoInformationCircleOutline,
  IoLocationOutline,
} from "react-icons/io5";
import { FaEllipsisH } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import { HiLocationMarker } from "react-icons/hi";

const pickPositiveMetric = (...values) => {
  for (const value of values) {
    if (value == null || value === "") continue;
    const num = Number(value);
    if (Number.isFinite(num) && num > 0) return num;
  }
  return 0;
};

const mapAgentListItem = (obj) => ({
  id: obj?.id ?? obj?._id,
  AgentName: obj?.name,
  AgentImage: obj?.profileImg,
  AgencySmallLogo: obj?.agencySmallLogo,
  TopHeadColor: obj?.primary_color,
  TopHeadImage: ag1,
  AgentAbout: obj?.agencyName,
  AgencyId: obj?.agencyId,
  AgentExperince: "10 years experience",
  Rating: obj?.average ?? 0,
  Review: obj?.reviews ?? [],
  PropertiesSoldAsLeadAgent: pickPositiveMetric(
    obj?.propertiesSoldAsLeadAgent,
    obj?.property_sold,
    obj?.propertiesSold,
  ),
  MedianDaysPrice: pickPositiveMetric(
    obj?.medianSoldPrice,
    obj?.medianSoldPriceAsLeadAgent,
    obj?.medianPrice,
  ),
  MediandaysAdvertised: obj?.medianDaysAdvertised ?? 0,
  PropertiesSold: pickPositiveMetric(
    obj?.propertiesSold,
    obj?.property_sold,
    obj?.propertiesSoldAsLeadAgent,
  ),
  medianSoldPrice: obj?.medianSoldPrice,
  medianPrice: obj?.medianPrice,
  medianSoldPriceAsLeadAgent: obj?.medianSoldPriceAsLeadAgent,
  property_sold: obj?.property_sold,
  propertiesSold: obj?.propertiesSold,
  propertiesSoldAsLeadAgent: obj?.propertiesSoldAsLeadAgent,
  VerifiedReview: obj?.reviews?.[0]?.review ?? "",
  RecentlySold: obj?.propertyDetails ?? [],
  primary_color: obj?.primary_color,
  secondary_color: obj?.secondary_color,
  text_color: obj?.text_color,
  job_title: obj?.job_title,
  agencyName: obj?.agencyName,
  agencyRegion: obj?.agencyRegion,
  suburb_area: obj?.suburb_area,
  suburb: obj?.suburb,
  state_region: obj?.state_region,
  phone: obj?.mobile_number,
});

const FindAgent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [IsActive, setIsActive] = useState(type === "agency" ? "Agencies" : "Agents");
  const [AgentData, setAgentData] = useState([]);
  const [selectedType, setSelectedType] = useState("All");
  const [selectedTimeframe, setSelectedTimeframe] = useState("12 months");
  const [timeframeOpen, setTimeframeOpen] = useState(false);
  const timeframeRef = useRef(null);
  const [filterCount] = useState(3);
  const [Filtered, setFiltered] = useState([]);
  const [FilteredAgency, setFilteredAgency] = useState([]);
  const deferredFilter = useDeferredValue(Filtered);
  const deferredFilteredAgency = useDeferredValue(FilteredAgency);
  const [Sort, setSort] = useState("");

  const [AgenciesData, setAgenciesData] = useState([]);
  const [Input, setInput] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [agentsFetchError, setAgentsFetchError] = useState(false);
  const [agenciesFetchError, setAgenciesFetchError] = useState(false);
  const [agentCurrentPage, setAgentCurrentPage] = useState(1);
  const agentPageSize = 6;
  useEffect(() => {
    if (type === "agency") {
      setIsActive("Agencies");
      GetAllAgenciesData();
    } else {
      setIsActive("Agents");
      GetAllAgentData();
    }
  }, [type, IsActive]);
  const normalizeSearch = (val) => String(val ?? "").toLowerCase().trim();

  const MIN_SEARCH_CHARS = 2;

  const filterData = (searchTerm) => {
    setFiltered(applyAgentFilter(AgentData, searchTerm));
  };

  const filterDataAgency = (searchTerm) => {
    setFilteredAgency(applyAgencyFilter(AgenciesData, searchTerm));
  };


  const handleSearchInput = (e) => {
    e.preventDefault();
    // Filter the data when the search term changes
    // const allValuealue = e?.target?.value;
    const value = e.target.value;
    filterData(value);
    filterDataAgency(value);
    setInput(value);
  };


  useEffect(() => {
    setAgentCurrentPage(1);
  }, [deferredFilter?.length, deferredFilteredAgency?.length, IsActive]);
  const { key } = useParams();

  const GetAllAgentData = async () => {
    setIsLoading(true);
    setAgentsFetchError(false);
    try {
      const response = await axiosInstanceAuth.post(
        `Agency_Agent/viewAllAgents/${key}`
      );
      const mydata = response?.data;
      if (response?.data?.status) {
        const agentData = mydata?.data;
        const newArray = (agentData ?? []).map(mapAgentListItem);
        setAgentData(newArray);
        setFiltered(applyAgentFilter(newArray, Input));
        setIsLoading(false);
      } else {
        toast.error(response.data.message);
        setAgentsFetchError(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Failed to load agents");
      setAgentsFetchError(true);
      setIsLoading(false);
    }
  };

  const GetAllAgenciesData = async () => {
    setIsLoading(true);
    setAgenciesFetchError(false);
    try {
      const res = await axiosInstanceAuth.get("agentadmin/viewAllAgency");
      const mydata = res?.data?.data;
      if (res?.data?.status) {
        const arr = Array.isArray(mydata) ? mydata : [];
        const newArray = arr.map((obj) => ({
          ...obj,
          id: obj?.id ?? obj?._id,
          TopHeadColor: obj?.primary_color,
          agencyLargeLogo: obj?.agencyLargeLogo,
          name: obj?.name,
          street: obj?.street,
          suburb_area: obj?.suburb_area,
          postcode: obj?.postcode,
          salesPerformance: obj?.salesPerformance,
          rentPerformance: obj?.rentPerformance,
          agencyReviews: obj?.agencyReviews,
        }));
        setAgenciesData(newArray);
        setFilteredAgency(applyAgencyFilter(newArray, Input));
        setIsLoading(false);
      } else {
        toast.error(res?.data?.message);
        setAgenciesFetchError(true);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Failed to load agencies");
      setAgenciesFetchError(true);
      setIsLoading(false);
    }
  };

  const SortAgent = async (data) => {
    setIsLoading(true);
    const response = await axiosInstanceAuth.post(`sortAgent`, {
      sort_by: data,
    });
    if (response.data.status) {
      const agentData = response?.data?.data;
      const newArray = agentData?.map(mapAgentListItem);
      setAgentData(newArray);
      setFiltered(applyAgentFilter(newArray, Input));
      setIsLoading(false);
    } else {
      toast.error(response.data.message);
      setIsLoading(false);
    }
  };

  const handleSelect = (e) => {
    setSort(e.target.value);
    SortAgent(e.target.value);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (timeframeRef.current && !timeframeRef.current.contains(e.target)) {
        setTimeframeOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const locationDisplay = key
    ? String(key)
      .replace(/-/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
    : "";

  const propertyTypes = ["All", "House", "Unit & Apartment"];
  const timeframeOptions = ["12 months", "6 months", "3 months"];

  const AgentCardSkeleton = () => (
    <div className="mb-6 rounded-2xl overflow-hidden bg-white shadow-sm border border-[#E5E7EB] animate-pulse">
      <div className="py-2.5 px-4 bg-[#E5E7EB] h-10" />
      <div className="p-4 md:p-6">
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex sm:items-start gap-4">
              <div className="w-[76px] h-[76px] rounded-full bg-[#E5E7EB] shrink-0" />
              <div className="space-y-2">
                <div className="h-5 bg-[#E5E7EB] rounded w-40" />
                <div className="h-3 bg-[#E5E7EB] rounded w-52" />
                <div className="h-6 bg-[#E5E7EB] rounded w-36 mt-2" />
                <div className="h-3 bg-[#E5E7EB] rounded w-28" />
                <div className="flex gap-2 mt-3">
                  <div className="h-6 bg-[#E5E7EB] rounded-full w-20" />
                  <div className="h-6 bg-[#E5E7EB] rounded-full w-24" />
                  <div className="h-6 bg-[#E5E7EB] rounded-full w-28" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
              <div>
                <div className="h-3 bg-[#E5E7EB] rounded w-20 mb-2" />
                <div className="grid grid-cols-3 gap-2">
                  <div className="bg-[#E5E7EB] rounded-lg h-16" />
                  <div className="bg-[#E5E7EB] rounded-lg h-16" />
                  <div className="bg-[#E5E7EB] rounded-lg h-16" />
                </div>
              </div>
              <div>
                <div className="h-3 bg-[#E5E7EB] rounded w-16 mb-2" />
                <div className="bg-[#E5E7EB] rounded-lg h-16" />
              </div>
              <div className="sm:col-span-2 flex flex-col gap-2">
                <div className="h-10 bg-[#E5E7EB] rounded-lg w-full max-w-[220px]" />
                <div className="flex gap-2">
                  <div className="h-10 bg-[#E5E7EB] rounded-lg w-24" />
                  <div className="h-10 bg-[#E5E7EB] rounded-lg w-24" />
                </div>
              </div>
            </div>
            <div className="bg-[#E5E7EB] rounded-lg p-4 space-y-2">
              <div className="flex gap-2">
                <div className="h-4 bg-[#D1D5DB] rounded w-24" />
                <div className="h-4 bg-[#D1D5DB] rounded w-32" />
              </div>
              <div className="h-3 bg-[#D1D5DB] rounded w-full" />
              <div className="h-3 bg-[#D1D5DB] rounded w-3/4" />
            </div>
            <div className="flex gap-3">
              <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-lg bg-[#E5E7EB]" />
              <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-lg bg-[#E5E7EB]" />
              <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-lg bg-[#E5E7EB]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const AgencyCardSkeleton = () => (
    <div className="w-full bg-gray-50 pb-8 animate-pulse">
      <div className="shadow-md overflow-hidden rounded-xl bg-white">
        <div className="p-0">
          <div className="mb-3">
            <div className="w-full h-12 bg-[#E5E7EB] rounded-t-xl" />
            <div className="flex flex-col md:flex-row justify-center items-start p-3 gap-4">
              <div className="w-full md:w-6/12 px-3 md:px-0 space-y-3">
                <div className="h-7 bg-[#E5E7EB] rounded w-48" />
                <div className="h-4 bg-[#E5E7EB] rounded w-64" />
                <div className="flex gap-2">
                  <div className="h-4 bg-[#E5E7EB] rounded w-12" />
                  <div className="h-4 bg-[#E5E7EB] rounded w-24" />
                </div>
                <div className="h-3 bg-[#E5E7EB] rounded w-40" />
                <div className="flex flex-wrap gap-2 mt-4">
                  <div className="h-7 bg-[#E5E7EB] rounded-full w-24" />
                  <div className="h-7 bg-[#E5E7EB] rounded-full w-20" />
                  <div className="h-7 bg-[#E5E7EB] rounded-full w-28" />
                </div>
              </div>
              <div className="w-full md:w-9/12 flex flex-col lg:flex-row gap-4 px-3 md:px-0 divide-y-2 lg:divide-y-0 lg:divide-x-2">
                <div className="pt-2 lg:pt-0">
                  <div className="h-4 bg-[#E5E7EB] rounded w-36 mb-4" />
                  <div className="flex justify-between gap-4">
                    <div className="space-y-2">
                      <div className="h-4 bg-[#E5E7EB] rounded w-8" />
                      <div className="h-6 bg-[#E5E7EB] rounded w-12" />
                      <div className="h-3 bg-[#E5E7EB] rounded w-40" />
                    </div>
                    <div className="space-y-2">
                      <div className="h-4 bg-[#E5E7EB] rounded w-8" />
                      <div className="h-6 bg-[#E5E7EB] rounded w-8" />
                      <div className="h-3 bg-[#E5E7EB] rounded w-32" />
                    </div>
                  </div>
                </div>
                <div className="pl-0 lg:pl-4 pt-4 lg:pt-0">
                  <div className="h-4 bg-[#E5E7EB] rounded w-36 mb-4" />
                  <div className="flex justify-between gap-4">
                    <div className="space-y-2">
                      <div className="h-4 bg-[#E5E7EB] rounded w-8" />
                      <div className="h-6 bg-[#E5E7EB] rounded w-12" />
                      <div className="h-3 bg-[#E5E7EB] rounded w-44" />
                    </div>
                    <div className="space-y-2">
                      <div className="h-4 bg-[#E5E7EB] rounded w-8" />
                      <div className="h-6 bg-[#E5E7EB] rounded w-8" />
                      <div className="h-3 bg-[#E5E7EB] rounded w-32" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="border-[#E5E7EB]" />
          <div className="pt-4 flex justify-end items-center px-6 pb-4">
            <div className="flex flex-col md:flex-row gap-3 w-full lg:w-[60%]">
              <div className="h-12 bg-[#E5E7EB] rounded-full w-full md:w-40" />
              <div className="h-12 bg-[#E5E7EB] rounded-full w-full md:w-48" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const applyAgentFilter = (sourceArray, searchTerm) => {
    const q = normalizeSearch(searchTerm);
    if (q.length < MIN_SEARCH_CHARS) return sourceArray ?? [];

    return (sourceArray ?? []).filter((obj) => {
      const allValue = `${obj?.AgentName ?? ""} ${obj?.id ?? ""} ${obj?.Rating ?? ""}`.toLowerCase();
      return allValue.includes(q);
    });
  };

  const applyAgencyFilter = (sourceArray, searchTerm) => {
    const q = normalizeSearch(searchTerm);
    if (q.length < MIN_SEARCH_CHARS) return sourceArray ?? [];

    return (sourceArray ?? []).filter((obj) => {
      const allValue = `${obj?.name ?? ""} ${obj?.id ?? ""}`.toLowerCase();
      return allValue.includes(q);
    });
  };

  const handleClearAgentSearch = () => {
    setInput("");
    setFiltered(applyAgentFilter(AgentData, ""));
  };

  const handleClearAgencySearch = () => {
    setInput("");
    setFilteredAgency(applyAgencyFilter(AgenciesData, ""));
  };

  const agentsBrowseTo = key ? `/find-agents/${key}` : "/find-agents";

  return (
    <>
      <Layout2>
        <div className="bg-white">
          <div className="pt-6 md:pt-8 pb-4 md:pb-6 px-3 md:px-0">
            <div className="flex items-center gap-1.5 text-sm md:text-base mb-4 md:mb-5">
              <span className="text-[#9CA3AF]">Find Agents</span>
              {locationDisplay && (
                <>
                  <span className="text-[#9CA3AF]">/</span>
                  <HiLocationMarker className="text-[#097FE6] w-4 h-4 shrink-0" />
                  <span className="text-[#333F48] font-medium">{locationDisplay}</span>
                </>
              )}
            </div>
            <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-4">
              <div className="inline-flex items-center bg-[#F3F6F9] rounded-full px-2 py-1.5 shrink-0">
                <button
                  className={`text-sm md:text-base py-2 px-5 w-full md:w-auto rounded-full font-medium transition-colors ${IsActive === "Agents" ? "bg-white text-[#333F48]" : "bg-transparent text-[#000929] hover:text-[#333F48]"}`}
                  onClick={() => {
                    setIsActive("Agents");
                    navigate(`/find-agents?type=agent`);
                  }}
                >
                  Agent
                </button>
                <button
                  className={`text-sm md:text-base py-2 px-5 w-full md:w-auto rounded-full font-medium transition-colors ${IsActive === "Agencies" ? "bg-white text-[#333F48]" : "bg-transparent text-[#000929] hover:text-[#333F48]"}`}
                  onClick={() => {
                    setIsActive("Agencies");
                    navigate(`/find-agents?type=agency`)
                  }}
                >
                  Agency
                </button>
              </div>
              <div className="relative flex flex-1 min-w-0 max-w-full md:w-[60%]  items-center bg-white border border-[#E5E5E5] rounded-full py-2.5 md:py-3 px-4 md:px-5 gap-2">
                <img src={search} alt="" className="w-4 h-4 shrink-0 opacity-50" />
                <input
                  type="text"
                  name="search"
                  placeholder="Broadbeach, QLD 4218"
                  value={Input ?? ""}
                  className="flex-1 min-w-0 text-sm md:text-base text-[#333F48] placeholder:text-[#9CA3AF] outline-none bg-transparent"
                  onChange={(e) => handleSearchInput(e)}
                />
                {(Input ?? "") !== "" && (
                  <button
                    type="button"
                    className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-[#E5E7EB] text-[#333F48] hover:bg-[#D1D5DB]"
                    onClick={() => setInput("")}
                    aria-label="Clear search"
                  >
                    <IoCloseOutline className="w-3.5 h-3.5" />
                  </button>
                )}
              </div>
              <div className="flex items-center gap-3 md:gap-4 shrink-0">
                <div ref={timeframeRef} className="relative min-w-[100px] md:min-w-[120px]">
                  <button
                    type="button"
                    onClick={() => setTimeframeOpen((v) => !v)}
                    className="w-full flex items-center justify-between bg-white border-[1.5px] border-[#EAEAEA] rounded-full py-2.5 md:py-3 px-4  text-sm md:text-base text-[#333F48] outline-none cursor-pointer hover:border-[#D1D5DB]"
                  >
                    <span className="pr-8">{selectedTimeframe}</span>
                    <MdKeyboardArrowDown
                      className={`absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280] transition-transform ${timeframeOpen ? "rotate-180" : ""}`}
                    />
                  </button>
                  {timeframeOpen && (
                    <div className="absolute top-full left-0 right-0 mt-1 z-10 bg-white border border-[#E5E7EB] rounded-md shadow-lg overflow-hidden">
                      {timeframeOptions.map((opt) => (
                        <button
                          key={opt}
                          type="button"
                          onClick={() => {
                            setSelectedTimeframe(opt);
                            setTimeframeOpen(false);
                          }}
                          className={`w-full text-left py-2.5 px-4 text-sm md:text-base transition-colors ${selectedTimeframe === opt ? "bg-[#3B82F6] text-white" : "text-[#333F48] hover:bg-[#F3F4F6]"}`}
                        >
                          {opt}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  className="flex items-center gap-2 bg-white border-[1.5px] border-[#EAEAEA] rounded-full py-2.5 md:py-3 px-4 text-sm md:text-base text-[#333F48] font-medium hover:bg-[#F9FAFB]"
                >
                  <IoFilter className="w-4 h-4 shrink-0" />
                  <span>Filters</span>
                  {filterCount > 0 && (
                    <span className="flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-[#3B82F6] text-white text-xs font-medium">
                      {filterCount}
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Layout2>
      <div className="pt-3 bg-[#F7F8F9]">
        <div className="container mx-auto px-2">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-5 gap-2">
            <div className="text-[#000929]">
              <h3 className="text-2xl font-semibold mb-3">
                {locationDisplay ? `Real Estate Agents in ${locationDisplay}` : `Real Estate ${type === "agency" ? "Agencies" : "Agents"}`}
              </h3>
              <h5 className="text-base font-normal flex items-center gap-3 ">
                {isLoading && IsActive === "Agents"
                  ? "Loading..."
                  : isLoading && IsActive === "Agencies"
                    ? "Loading..."
                    : (() => {
                      const activeFiltered = IsActive === "Agencies" ? deferredFilteredAgency : deferredFilter;
                      const total = activeFiltered?.length ?? 0;
                      if (total === 0) return "Showing 0 results";
                      if (IsActive === "Agencies") return `Showing 1 - ${total} of ${total} results`;
                      const start = (agentCurrentPage - 1) * agentPageSize + 1;
                      const end = Math.min(agentCurrentPage * agentPageSize, total);
                      return `Showing ${start} - ${end} of ${total} results`;
                    })()}
              </h5>
            </div>
            <div className="text-[14px] font-normal flex items-start gap-3 md:items-center">
              <span className="opacity-40">Sorted by:</span>
              <span className="opacity-100 text-[#000929]">Suburb sales & performance</span> <IoInformationCircleOutline size={16} className="opacity-40" />
            </div>
          </div>
          {IsActive === "Agents" ? (
            isLoading ? (
              <div className="mb-10">
                {[1, 2, 3].map((key) => (
                  <AgentCardSkeleton key={key} />
                ))}
              </div>
            ) : (
              <FindAgentCard
                AgentData={deferredFilter}
                style="mb-10"
                currentPage={agentCurrentPage}
                onPageChange={setAgentCurrentPage}
                pageSize={agentPageSize}
                fetchError={agentsFetchError}
                onRetry={GetAllAgentData}
                agentSourceCount={AgentData.length}
                onClearSearch={handleClearAgentSearch}
                browseTo={agentsBrowseTo}
              />
            )
          ) : null}
          {IsActive === "Agencies" ? (
            isLoading ? (
              <div className="mb-10">
                {[1, 2, 3].map((key) => (
                  <AgencyCardSkeleton key={key} />
                ))}
              </div>
            ) : (
              <FindAgencyCard
                AgenciesData={Input ? deferredFilteredAgency : AgenciesData}
                style="mb-10"
                fetchError={agenciesFetchError}
                onRetry={GetAllAgenciesData}
                agencySourceCount={AgenciesData.length}
                onClearSearch={handleClearAgencySearch}
                browseTo={agentsBrowseTo}
              />
            )
          ) : null}
        </div>
      </div>
    </>
  );
};

export default FindAgent;
